;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { ContentRichText } from "../../content/contentRenderPrimitives"
import type { RichTextField } from "../../../lib/content/legacyBlockTypes"
import { getContentRichTextComponents } from "../../content/ContentRichTextLink"
import { cn } from "../../../../lib/utils"

type LandingRichTextProps = {
  field?: RichTextField | null
  className?: string
}

export default function LandingRichText({ field, className }: LandingRichTextProps) {
  if (!field || field.length === 0) return null

  return (
    <div
      className={cn(
        "text-[#3f4649] [&_a]:font-bold [&_a]:text-[#065e6f] [&_a]:underline-offset-2",
        className,
      )}
    >
      <ContentRichText
        field={field}
        components={getContentRichTextComponents({
          paragraph: ({ children }) => (
            <p className="mb-4 text-[17px] leading-[1.6] tracking-normal text-[#3f4649] min-[700px]:text-[18px]">
              {children}
            </p>
          ),
          heading2: ({ children }) => (
            <h2 className="mb-4 font-bebas text-[32px] font-medium leading-tight tracking-normal text-[#092c3c]">
              {children}
            </h2>
          ),
          heading3: ({ children }) => (
            <h3 className="mb-3 text-[21px] font-bold leading-snug tracking-normal text-[#092c3c]">
              {children}
            </h3>
          ),
          list: ({ children }) => (
            <ul className="mb-4 mt-3 ml-0 list-none space-y-2 pl-0">{children}</ul>
          ),
          oList: ({ children }) => (
            <ol className="mb-4 mt-3 ml-0 list-none space-y-2 pl-0">{children}</ol>
          ),
          listItem: ({ children }) => (
            <li className="relative pl-5 text-[17px] leading-[1.55] text-[#3f4649] before:absolute before:left-0 before:top-[0.7em] before:h-[6px] before:w-[6px] before:rounded-full before:bg-[#00b2ff] min-[700px]:text-[18px]">
              {children}
            </li>
          ),
          oListItem: ({ children }) => (
            <li className="ml-5 list-decimal pb-1 text-[17px] leading-[1.55] text-[#3f4649] min-[700px]:text-[18px]">
              {children}
            </li>
          ),
        })}
      />
    </div>
  )
}
